<template lang="pug">
.ticket-wrapper
  .upright.showInMobile {{ $t('common.ticket') }} &nbsp; {{ticketIndex + 1}}
  section.ticket(:class="{'returned': ticket.returnedAt && ticket.returnedAt.length}")
    .ticket__left
      //- template(v-if="")
      //- if image is failed or no image show box 100x100 with icon
      // picture.ticket__image
        img(:src="ticket.performance.image['170x240']")
        // 100x140
      .upright.showInDesktop {{ $t('common.ticket') }} &nbsp; {{ticketIndex + 1}}
      .ticket__left-wrapper
        // .ticket__qr(v-if="ticket.returned_at == null && tab !== 'used'")
          // 100x100
        qr-code-vue.qr-margin(v-if="ticket.returned_at == null && tab !== 'used'" :value="ticket.qr" :size="100" level="H")

        arc-button.return-ticket(style="", v-if="!ticket.returned_at && tab !== 'used' && tab !== 'booked'", :name="$t('common.returnTicket')", @click="returnOne()", outline-gray)

    .ticket__right
      // .wrapper_title.mobile-wrapper
        // .ticket__tag {{$t('common.cinemaTickets')}}
        .ticket__footer.into_mobile_wrapper
            // arc-button.returnHover(v-if="ticket.button", :name="ticket.button.name", @click.prevent="prolong(ticket.button.url)", outline-gray, style="color: black;border: 1px solid black;background: #fff;",)
            arc-button.returnHover(style="color: #FF0000;margin-bottom:30px;border: 1px solid red;", v-if="!ticket.returned_at && tab !== 'used' && tab !== 'booked'", :name="$t('common.returnTicket')", @click="returnOne()", outline-gray)
      .ticket__tag.ticket__tag-canceled(v-if="ticket.returnedAt && ticket.returnedAt.length") {{ $t('canceled') }}
      // .title_mobile_wrapper
      .ticket__title {{ ticket.performance.name }}
      .ticket__table
        .ticket__table-line.line-through(v-if="ticket.returned_at != null") <span>{{ ticket.ticket_code }}</span><p>({{ $t('returned') }})</p>
        // .ticket__table-line(v-if="ticket.returned_at == null") <span>{{ ticket.ticket_code }}</span>
        .ticket__table-line
          | <span>{{convertToUTC(ticket.session.timeSpending) | moment('DD MMMM YYYY HH:mm')}}</span>
        br
        .ticket__table-line <span>{{ticket.session.object.name}}</span>
        br
        br
        .ticket__table-line.table-line_wrapper {{$t('common.sector')}}: <span>{{ ticket.section_name }}</span>
        .ticket__table-line.table-line_wrapper {{$t('common.hall')}}: <span>{{ ticket.hall_name }}</span>
        .ticket__table-line.table-line_wrapper {{$t('common.row')}}: <span>{{ ticket.row }}</span>
        .ticket__table-line {{$t('common.place')}}: <span>{{ ticket.place }}</span>
        // .ticket__table-line__wrapper(style="display:flex;flex-wrap:wrap;")
          .ticket__table-line.table-line_wrapper {{$t('common.sector')}}: <span>{{ ticket.section_name }}</span>
          .ticket__table-line.table-line_wrapper {{$t('common.hall')}}: <span>{{ ticket.hall_name }}</span>
          .ticket__table-line.table-line_wrapper {{$t('common.row')}}: <span>{{ ticket.row }}</span>
          .ticket__table-line {{$t('common.place')}}: <span>{{ ticket.place }}</span>

        // .ticket__table-line__wrapper(style="display:flex")
        // .ticket__table-line.table-line_wrapper {{$t('common.price')}}: <span>{{ ticket.price | price }} {{ getLayout.currency_symbol ? getLayout.currency_symbol : $t('currency.rub') }}</span>
        // .ticket__table-line {{$t('common.commission')}}
          |: <span>{{ ticket.commission | price }} {{ getLayout.currency_symbol ? getLayout.currency_symbol : $t('currency.rub') }}</span>
        // .ticket__table-line.table-line_wrapper {{$t('common.discount')}}: <span>{{ ticket.discount | price }} руб.</span>
      // .ticket__price {{$t('common.total')}}: {{ ticket.amount | price }} руб.
      .ticket__footer
        // empty block
        //- arc-button(name="Распечатать билет", outline-gray)
        //- arc-button(name="Скачать", outline-gray)
        // arc-drop-button(v-if="!ticket.returnedAt", :name="$t('common.operations')", top, :list="more",
          @action="doAction", outline-gray)
        // arc-button.returnHover(v-if="ticket.button", :name="ticket.button.name", @click="prolong(ticket.button.url)", outline-gray, style="color: black;border: 1px solid black;background: #fff;",)
        // arc-button.returnHover(style="color: #FF0000;border: 1px solid red;", v-if="!ticket.returned_at && tab !== 'used' && tab !== 'booked'", :name="$t('common.returnTicket')", @click="returnOne()", outline-gray)
      // .flex_wrapper
        .ticket__qr#qr_mobile(v-if="ticket.returned_at == null && tab !== 'used'")
          // 100x100
          qr-code-vue(:value="ticket.qr" :size="80" level="H")
        arc-button.returnHover(style="color: #FF0000;margin-bottom:30px;border: 1px solid red;", v-if="!ticket.returned_at && tab !== 'used' && tab !== 'booked'", :name="$t('common.returnTicket')", @click="returnOne()", outline-gray)
    popup-return(v-if="showReturn", :orderId="orderId", :ticket="ticket",
      @close="showReturn = false", @onReturn="update()")
    popup-cancel(v-if="showCancel", :orderId="orderId", :ticketId="ticket.id",
      @close="showCancel = false", @onCancel="update()")
</template>

<script>
import { mapGetters } from 'vuex';
import QrCodeVue from 'qrcode.vue';

import popupReturn from '@/components/popups/return.vue';
import popupCancel from '@/components/popups/cancel.vue';

// calculate this shit
// let q = 0;
// Array.prototype.forEach.call(document.querySelectorAll('.order__dedicate .ticket'), (e) => {
//   q += e.getBoundingClientRect().height;
// });
// console.log(q);

export default {
  name: 'Ticket',
  props: {
    ticket: {
      type: Object,
      default: () => (null),
      required: false,
    },
    orderId: {
      type: Number,
      required: true,
    },
    tab: {
      type: String,
      required: true,
    },
    ticketIndex: {
      type: Number,
      required: false,
    },
  },
  data: () => ({
    showReturn: false,
    showCancel: false,
    more: [],
    isMobile: false,
  }),
  computed: {
    ...mapGetters({
      getLayout: 'getLayout',
    }),
  },
  mounted() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      this.isMobile = true;
    }
    this.makeMore();
  },
  methods: {
    makeMore() {
      if (!this.ticket.qr && !this.ticket.returnedAt) {
        this.more.push({
          action: 'cancel', name: 'Отменить',
        });
      }
      if (this.check(this.ticket) && !this.ticket.returnedAt) {
        this.more.push({
          action: 'return', name: 'Возврат',
        });
      }
    },
    getDisabled(time) {
      return time > Math.floor(Date.now() / 1000);
    },
    doAction(params) {
      if (params.action === 'cancel') {
        this.showCancel = true;
      }
      if (params.action === 'return') {
        this.showReturn = true;
      }
    },
    check(ticket) {
      if (ticket.qr && !(ticket.scanned_at || ticket.printed_at)
        && this.getDisabled(ticket.session.timeSpending)
        && ticket.total_amount > 0) {
        return true;
      }
      return false;
    },
    update() {
      this.$emit('update');
      this.showReturn = false;
      this.showCancel = false;
    },
    returnOne() {
      this.showReturn = true;
    },
    prolong(link) {
      window.open(link, '_blank');
    },
    convertToUTC(timestamp) {
      const tz = this.getTimezoneOffset(Intl.DateTimeFormat().resolvedOptions().timeZone) / 60;
      let utc = 3;

      if (window && window.location.href.match(/guru.ge/)) {
        utc = 4;
      }

      const diff = (-tz + utc) * 3600;
      console.log('tz', tz);
      return timestamp + diff;
    },
    getTimezoneOffset(timezone) {
      const now = new Date();
      const timezoneDate = new Date(now.toLocaleString('en-US', { timeZone: timezone }));
      const utcDate = new Date(now.toLocaleString('en-US', { timeZone: 'UTC' }));
      const offset = (timezoneDate.getTime() - utcDate.getTime()) / 60000;
      return offset;
    },

  },
  components: {
    QrCodeVue,
    popupReturn,
    popupCancel,
  },
};
</script>

<style lang="scss">
.line-through {
  display: flex;
  flex-direction: row;
}
.line-through span{
  text-decoration: line-through;
}
.line-through p{
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
  color: brown;
}

.ticket:first-child {
  border-top: 0;
}

.upright {
  @media screen and (min-width: 960px){
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    transform:rotate(-90deg);
  }

  @media screen and (max-width: 960px){
    margin-top: 22px;
    margin-bottom: 10px;
  }

  margin-top: 40px;
  white-space: nowrap;
  font-size: 20px;
  font-weight: 600;
}

.qr-margin {
  @media screen and (max-width: 960px){
    margin-bottom: 10px;
  }
}

.return-ticket {
  @media screen and (min-width: 960px){
    color: #FF0000;
    border: 1px solid red;
    margin-top: 10px;
  }
  @media screen and (max-width: 960px){
    background: #fff;
  }
}

.ticket-wrapper {
  background: #efefef;
  border-top: 2px dashed lightgray;
  @media screen and (max-width: 960px){
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.ticket {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;

  @media screen and (max-width: 960px) {
    align-self: baseline;
  }

  // background: #efefef;

  padding: 0;

  // border-top: 2px dashed lightgray;

  &.returned {
    .ticket__title, .ticket__table-line, .ticket__price {
      color: #dad7d7;
    }
    .def-item-icon__train {
      background-color: #0099ff69;
    }
    .ticket__tag {
      background-color: #0099ff69;
      &-canceled {
        margin-left: .5rem;
        background-color: #ee4747;
      }
    }
    .er-status{
      border: 1px solid #0099ff69;
      color: #0099ff69;
       &.no-er {
      border: 1px solid #dba3a3;
      border-radius: 4px;
      color: #dba3a3;
    }
    }
  }

  &__left {
    // min-width: 100px;
    // max-width: 100px;
    // width: 100px;
    margin: 40px 0 40px 5px;
    display: flex;
    // flex-direction: column;
    justify-content: flex-start;
    align-items: start;
    @media screen and (max-width: 960px) {
      flex-direction: column;
      margin: 3px 0 40px 10px;
      // padding: 10px;
    }
  }
  &__left-wrapper {
    min-width: 100px;
    max-width: 100px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;
  }
  &__image {
    width: 100px;
    // height: 140px;
    margin-bottom: 20px;
    > img {
      border-radius: 4px;
      width: 100%;
    }
  }
  &__qr {
    min-width: 100px;
    max-width: 100px;
    width: 100px;
    max-height: 100px;
    min-height: 100px;
    height: 100px;
    border-radius: 4px;
    border: solid 1px rgb(229, 229, 229);
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
    @media screen and (max-width:960px) {
      margin-bottom: 0;
      min-width: 140px;
      max-width: 140px;
      width: 140px;
      max-height: 140px;
      min-height: 140px;
      height: 140px;
      // > div > canvas {
      // width: 120px !important;
      // height: 120px !important;
      // }
    }
  }

  .er-status {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
    width: 100px;
    border: 1px solid rgb(0, 153, 255);
    border-radius: 4px;
    text-align: center;
    color: rgb(0, 153, 255);
    font-size: 11px;
    &.no-er {
      border: 1px solid #ee4747;
      border-radius: 4px;
      color: #ee4747;
    }
    .mark {
      width: 80px;
    }
  }

  &__right {
    width: 100%;
    margin: 40px 45px 40px 30px;
  }
  &__table {
    &-line {
      padding: 0 0 3px 0;
      font-family: Inter;
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      // white-space: nowrap;
      line-height: normal;
      letter-spacing: normal;
      color: rgb(0, 0, 0);
      // border-top: 1px dashed rgb(229, 229, 229);
      > span {
        font-weight: 500;
      }
    }
    // border-bottom: 1px dashed rgb(229, 229, 229);
  }
  &__tag {
    display: inline-block;
    height: 30px;
    margin-bottom: 30px;
    font-family: Inter;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: rgb(255, 255, 255);
    border-radius: 3px;
    background-color: rgb(0, 153, 255);
    padding: 10px;
  }
  &__title {
    font-family: Inter;
    font-size: 18px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: rgb(0, 0, 0);
    margin-bottom: 24px;
    @media screen and (max-width:960px) {
      font-size: 16px;
      word-break: break-word;
    }
  }
  &__price {
    // margin-top: 29px;
    // margin-bottom: 36px;
    margin-top: 18px;
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: rgb(0, 0, 0);
  }
  &__footer {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    > * {
      margin: 0 5px;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.table-line_wrapper {
  position: relative;
  margin-right:3rem;
}

// .table-line_wrapper:after{
//   content: " ";
//   background: #d3d3d3;
//   width: 2px;
//   height: 2rem;
//   /* линия смещена на 10px справа от текста*/
//   right: -1.5rem;
//   bottom: .8rem;
//   /* включаем абсолютное позиционирование относительно блока с relative */
//   position: absolute;
// }
.returnHover {
  margin-top: 1rem;
  @media screen and (max-width:960px) {
    margin-top: 0rem;
  }
}
.returnHover:hover {
  background-color: #fff;
  border: 1px solid #FF0000;
}
.wrapper_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
